














































import CompanyUserRequired from "../../CompanyRequired";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import {TerminalLocationShortInfo} from "../../../modules/models";

@Component
export default class AddLocation extends CompanyUserRequired {
  @Inject()
  api!: Api;

  @Prop({default: false})
  value!: boolean;

  get open() {
    return this.value;
  }
  set open(v: boolean) {
    if(v != this.value) {
      this.$emit("input", v);
    }
  }

  locationList: TerminalLocationShortInfo[] = [];

  get filteredList() {
    const st = this.searchTxt.trim().toLowerCase();
    if(this.searchTxt.trim().length == 0) {
      return this.locationList;
    } else {
      return this.locationList.filter(loc =>
          loc.description.toLowerCase().includes(st) ||
          loc.id.toString() == st ||
          (st.length > 4 && loc.company.orgNum.toString().includes(st)) ||
          loc.company.name.toLowerCase().trim().includes(st)
      );
    }
  }

  async loadLocationList() {
    this.locationList = await this.api.fetchAllTermlocsShortInfo();
  }

  locationSelected(loc: TerminalLocationShortInfo) {
    this.$emit("at-location-selected", loc)
  }

  searchTxt = "";

  created() {
    this.loadLocationList();
  }
}
